<style scoped>
.package{display: flex;flex-direction: column;width: 100%;height: 100%;overflow: auto;}
.legnd{width: 100%;}
#legend{width: 100%;}
</style>

<template>
  <div style="overflow: auto;">
    <div class="package">
      <div class="legnd">
        <div  v-if="ImgAry.length > 0">
          <img id="legend" v-for="(each, index) in ImgAry" :key="index" :src="each.img">
        </div>
        <div v-else>
          <p style="color: #fff;font-size:18px;">暂无数据</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'ol/ol.css'
import TileLayer from 'ol/layer/Tile'
import TileWMS from 'ol/source/TileWMS'
import XYZ from 'ol/source/XYZ'
import WMTS from 'ol/source/WMTS'
import WMTSTileGrid from 'ol/tilegrid/WMTS'
import PropertiesView from './PropertiesView'
import Axios from 'axios'
export default {
  components: {PropertiesView},
  data()
  {
    return {
      imgary: [],
      layerary: []
    }
  },
  computed:
  {
    ImgAry()
    {
      return this.imgary
    }
  },
  mounted()
  {
  },
  methods:
  {
    //当前节点选中状态发生变化时触发
    onChange(node, checked, checkild)
    {
      let layer
      layer = this.showLegend(node, checked)
      if (checked && !checkild)
      {
        let flag = this.controlShow(node, checked)
        if (layer)
          this.layerary.push(layer)
        if (!flag && layer)
        {
          //加载切片底图
          this.loadWMTSlayer(node)
          //不加载矢量图，如果需要加载把此判断去掉即可
          if (node.filter === 'XYZ')
            window.map.addLayer(layer)
        }
      }
      else if (!checked && !checkild)
      {
        this.controlShow(node, checked)
        let index = this.layerary.findIndex(e => e.values_.namee === node.name)
        if (index !== -1)
          this.layerary.splice(index, 1)
      }
      // console.log(this.layerary)
    },
    /**
     * 控制图层显隐效果
     * @method
     * @param {Object} node 选中节点数据
     * @param {Boolent} checked 是否被选中
     */
    controlShow(node, checked)
    {
      let flag
      window.map.getLayers().forEach(e =>
      {
        let Attribute = e.getProperties().title
        if (Attribute === node.namec)
        {
          e.setVisible(checked)
          flag = true
        }
      })
      //返回是否已经加载
      if (flag)
        return true
    },
    //加载矢量图层
    showLegend(node, checked)
    {
      let layers
      //加载wms图层
      if (node.filter === 'WMS')
      {
        const wmsSource = new TileWMS({
          url: 'http://www.camining.cn/geoserver/gisdny/wms',
          params: {
            LAYERS: node.maptype
          },
          className: 'tucheng'
        })
        if (checked)
          this.imgary.push({img: node.icon, id: node.id})
        else
        {
          let index = this.imgary.findIndex(e => e.id === node.id)
          this.imgary.splice(index, 1)
        }
        layers =  new TileLayer({
          title: node.namec,
          namee: node.name,
          source: wmsSource,
          visible: true
        })
      }
      //加载天地图
      else if (node.filter === 'XYZ')
      {
        layers = new TileLayer({
          title: node.namec,
          namee: node.name,
          source: new XYZ({
            url: node.url
          }),
          visible: true
        })
      }
      return layers
    },
    //加载arcgis切片图层
    loadWMTSlayer(node)
    {
      if (node.filter !== 'WMS')
        return false
      let layer = node.type.split(':')[1].split('_')[1]
      let resolutions = []
      if ((node.glid === 914 && node.namec === '柬埔寨矿权') || node.namee === 'Cambodia2')
        resolutions = [0.009517252285972435, 0.004758626142986218, 0.002379313071493109, 0.0011896565357465544, 0.0005948282678732772, 0.0002974141339366386, 0.0001487070669683193, 0.00007435353348415965]
      else if (node.glid === 914 && node.namec === '印度尼西亚矿权')
        resolutions = [0.03806900914388974, 0.01903450457194487, 0.009517252285972435, 0.004758626142986218, 0.002379313071493109, 0.0011896565357465544, 0.0005948282678732772, 0.0002974141339366386]
      else if (node.glid === 914 || node.namee === 'Vietnam1')
        resolutions = [0.01903450457194487, 0.009517252285972435, 0.004758626142986218, 0.002379313071493109, 0.0011896565357465544, 0.0005948282678732772, 0.0002974141339366386, 0.0001487070669683193]
      else if (node.glid === 870 && node.namec !== '机场')
        resolutions = [0.07613801828777948, 0.03806900914388974, 0.01903450457194487, 0.009517252285972435, 0.004758626142986218, 0.002379313071493109, 0.0011896565357465544, 0.0005948282678732772]
      else
        resolutions = [0.15228550437313793, 0.07614275218656896, 0.03807137609328448, 0.01903568804664224, 0.00951784402332112, 0.00475892201166056, 0.00237946100583028, 0.00118973050291514, 5.9486525145757E-4]
      var tileGridWMTS = new WMTSTileGrid({
        resolutions: resolutions,
        //原点
        origin: [-400.0, 399.9999999999998],
        tileSize: 256,
        matrixIds: [`${node.type}:0`, `${node.type}:1`, `${node.type}:2`, `${node.type}:3`, `${node.type}:4`, `${node.type}:5`, `${node.type}:6`, `${node.type}:7`, `${node.type}:8`]
      })
      var smOption = {
        tileGrid: tileGridWMTS,
        matrixSet: node.type,
        projection: 'EPSG:4326',
        layer: layer,
        style: '',
        version: '1.0.0',
        format: 'image/png',
        transition: 0,
        opaque: 0,
        url: 'http://www.camining.cn/geowebcache/service/wmts'
      }
      var lyr = new TileLayer({
        title: node.namec,
        namee: node.name,
        source: new WMTS(smOption)
      })
      window.map.addLayer(lyr)
    },
    //属性查看
    attrQuery(Layernar)
    {
      let self = this
      if (this.layerary.length === 0)
        return this.$message.warning('请先勾选图层')
      this.key = window.map.on('click', async(e) =>
      {
        // this.$parent.loading = true
        let viewResolution = window.map.getView().getResolution()
        for (let layer of this.layerary)
        {
          this.$parent.loading = true
          let url = layer.getSource().getFeatureInfoUrl(e.coordinate, viewResolution, 'EPSG:4326', {'INFO_FORMAT': 'text/html'})
          if (url)
          {
            let wmsRet = await Axios.get(url)
            debugger
            let wmsData = self.$x2js.xml2js(wmsRet.data)
            if (wmsData.html.body.table)
            {
              //lzy20211119
              let pointary = this.analysisAttribute(wmsData.html.body.table.tr)
              if (Object.keys(pointary).length > 0)
              {
                this.$parent.loading = false
                self.$emit('propertiesview', pointary, e)
              }
              break
            }
            else
            {
              this.$emit('closerFrame')
              this.$parent.loading = false
            }
          }
        }
      })
    },
    //解析查询属性
    analysisAttribute(table)
    {
      let attribute = {}
      for (let i = 0; i < table[0].th.length; i++)
      {
        let each = table[0].th[i]
        attribute[each] =  table[1].td[i]
      }
      return attribute
    },
    //关闭属性查看
    closeQuery()
    {
      if (this.key)
        window.map.un(this.key.type, this.key.listener)
      //关闭弹框
      this.$emit('closerFrame')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/kyyzt/Legend.vue